/**
 * @desc 获取C端用户授权状态接口
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/user/userIsAuthorized',
    params,
    method: 'get',
  })
}
